// external
import React, { Component } from "react";
import { PropTypes } from "prop-types";

// internal
import { customize } from "utils/hoc/Customize";

class CustomTextUI extends Component {
  constructor(props) {
    super(props);

    let section = props.hovered ? "text_hover" : "text";

    if (props.isTitle) section = props.hovered ? "title_hover" : "title";

    this.state = {
      textStyles: props.getStyles(`${props.namespace}:${section}`),
    };
  }

  componentDidUpdate(prevProps) {
    const { hovered, namespace, getStyles } = this.props;

    if (prevProps.hovered !== hovered) {
      this.setState({
        textStyles: getStyles(`${namespace}:${this.getSection()}`),
      });
    }
  }

  getSection = () => {
    const { isTitle, hovered } = this.props;

    let section = hovered ? "text_hover" : "text";

    if (isTitle) section = hovered ? "title_hover" : "title";

    return section;
  };

  onLink = () => {
    let section = this.getSection();

    if (this.props.enableHover) {
      section = "text_hover";
      if (this.props.isTitle) section = "title_hover";
    }

    this.setState({
      textStyles: this.props.getStyles(`${this.props.namespace}:${section}`),
    });
  };

  onLinkOver = () => {
    const section = this.getSection();

    this.setState({
      textStyles: this.props.getStyles(`${this.props.namespace}:${section}`),
    });
  };

  render() {
    const { children, className, onClick } = this.props;
    const styles = this.state.textStyles;

    return (
      <div
        style={styles}
        className={className}
        onClick={onClick}
        onMouseEnter={this.onLink}
        onMouseLeave={this.onLinkOver}
      >
        {children}
      </div>
    );
  }
}

CustomTextUI.propTypes = {
  children: PropTypes.node.isRequired,
  getStyles: PropTypes.func.isRequired,
  className: PropTypes.string,
  isTitle: PropTypes.bool,
  enableHover: PropTypes.bool,
  hovered: PropTypes.bool,
  namespace: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

CustomTextUI.defaultProps = {
  isTitle: false,
};

export default customize()(CustomTextUI);
